import React, { useState, useEffect, forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
// import ClearIcon from "@material-ui/icons/Clear";

import "../Curso/Curso.css";
import "../Element/Element.css";

import { dataActions } from "../../store/data-slice";

import Checkbox from "react-simple-checkbox";
import { useTranslation } from "react-i18next";
import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";

export const Curso = forwardRef(
  (
    {
      id,
      title,
      price,
      checked,
      quantity,
      handleIncluir,
      updateCourseQuantity,
    },
    ref
  ) => {
    const [isChecked, setisChecked] = useState(false);
    const [courseQuantity, setCourseQuantity] = useState(null);

    const persons_number = useSelector(
      (state) => state.data.practicas.personas
    );
    const extras_inputListCM = useSelector(
      (state) => state.data.extrasInputListCM
    );
    const extras_inputListEE = useSelector(
      (state) => state.data.extrasInputListEE
    );
    const extras_inputListEC = useSelector(
      (state) => state.data.extrasInputListEC
    );
    const limitEE = extras_inputListEE.length;
    const limitCM = extras_inputListCM.length;
    const [t] = useTranslation("global");
    const dispatch = useDispatch();

    useEffect(() => {
      if (checked) {
        setisChecked(true);
      } else {
        setisChecked(false);
      }

      setCourseQuantity(quantity);
    }, [quantity, checked]);

    const handleChecked = (e) => {
      setisChecked(!isChecked);

      handleIncluir(e, {
        id,
        title,
        price,
        courseQuantity,
      });
    };

    const handleAddClick = (id) => {
      if (id === "CM") {
        dispatch(dataActions.setExtrasInputListCM([...extras_inputListCM, ""]));
      }
      if (id === "EE") {
        dispatch(dataActions.setExtrasInputListEE([...extras_inputListEE, ""]));
      }

      if (id === "EC" && quantity % 4 === 0) {
        dispatch(dataActions.setExtrasInputListEC([...extras_inputListEC, {}]));
      }

      setCourseQuantity(courseQuantity + 1);
      updateCourseQuantity({
        id,
        title,
        price,
        courseQuantity: courseQuantity + 1,
      });
    };

    const handleRemoveInput = (id, idx = 0) => {
      setCourseQuantity(courseQuantity - 1);
      updateCourseQuantity({
        id,
        title,
        price,
        courseQuantity: courseQuantity - 1,
      });

      if (id === "CM") {
        dispatch(
          dataActions.setExtrasInputListCM([...extras_inputListCM.slice(0, -1)])
        );
      }

      if (id === "EE") {
        dispatch(
          dataActions.setExtrasInputListEE([...extras_inputListEE.slice(0, -1)])
        );
      }

      if (id === "EC") {
        if ((quantity - 1) % 4 === 0) {
          dispatch(
            dataActions.setExtrasInputListEC([
              ...extras_inputListEC.slice(0, -1),
            ])
          );
        }
      }
    };

    return (
      <>
        <div className="curso__cursoContainer">
          <div className="curso__curso">
            <div className="curso__info">
              <div className="curso__infoTitle">{title}</div>
              <div className="curso__infoPrecio">
                {price}€ {id === "EC" ? t("EXTRAS.cursos.EC_desc") : ""}
              </div>
            </div>
            <div className="curso__checkboxContainer">
              <div className="curso__checkboxIncluir">
                {t("EXTRAS.include")}
              </div>
              <div className="curso__checkbox">
                <Checkbox
                  checked={isChecked}
                  size={4}
                  color="#499BB1"
                  tickAnimationDuration="100"
                  backAnimationDuration="100"
                  onChange={(e) => {
                    handleChecked(e);
                  }}
                />
              </div>
            </div>
          </div>
          <SlideDown>
            {isChecked && (
              <>
                <div>
                  <div className="curso__bottomIcons">
                    <div className="element__icons">
                      <div className="element__profileIcon">
                        <PersonOutlineIcon style={{ fontSize: 30 }} />
                      </div>
                      <div className="element__decrement">
                        <button
                          onClick={() => {
                            handleRemoveInput(id);
                          }}
                          disabled={courseQuantity == 1}
                        >
                          <RemoveCircleOutlineIcon style={{ fontSize: 30 }} />
                        </button>
                      </div>
                      <div className="element__counter">{courseQuantity}</div>
                      <div className="element__increment">
                        <button
                          onClick={() => {
                            handleAddClick(id);
                          }}
                          disabled={courseQuantity == persons_number}
                        >
                          <AddCircleOutlineIcon style={{ fontSize: 30 }} />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>
                    {courseQuantity !== persons_number && (
                      <>
                        {/* //! Desplegable del Certificado Médico */}
                        {id === "CM" && (
                          <>
                            {extras_inputListCM
                              .slice(0, limitCM)
                              .map((_, idx) => {
                                return (
                                  <div
                                    key={idx}
                                    className="screen__inputsBottom"
                                  >
                                    {/* {courseQuantity > 1 && (
                                      <div
                                        onClick={() => {
                                          handleRemoveInput(id, idx);
                                        }}
                                      >
                                        <ClearIcon />
                                      </div>
                                    )} */}
                                    <div className="screen__inputContainer">
                                      <input
                                        name={`inputCM${idx}`}
                                        type="text"
                                        defaultValue={extras_inputListCM[idx]}
                                        placeholder={t("EXTRAS.name")}
                                        ref={(el) => (ref.current[idx] = el)}
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                          </>
                        )}
                        {/* //! Desplegable de la Expedición Express     */}
                        {id === "EE" && (
                          <>
                            {extras_inputListEE
                              .slice(0, limitEE)
                              .map((_, idx) => {
                                return (
                                  <div
                                    key={idx}
                                    className="screen__inputsBottom"
                                  >
                                    {/* {courseQuantity > 1 && (
                                      <div
                                        onClick={() => {
                                          handleRemoveInput(id, idx);
                                        }}
                                      >
                                        <ClearIcon />
                                      </div>
                                    )} */}
                                    <div className="screen__inputContainer">
                                      <input
                                        name={`inputEE${idx}`}
                                        type="text"
                                        defaultValue={extras_inputListEE[idx]}
                                        placeholder={t("EXTRAS.name")}
                                        ref={(el) => (ref.current[idx] = el)}
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                          </>
                        )}
                      </>
                    )}
                    {/*//! Desplegable del envio por correo */}
                    {id === "EC" && (
                      <>
                        {extras_inputListEC.map((el, idx) => {
                          return (
                            <div key={idx} className="screen__inputsBottomEC">
                              <div className="screen__inputContainerEC">
                                {extras_inputListEC.length > 1 && (
                                  <div className="screen__titleEC">
                                    <h3 className="screen__titleEC-title">
                                      {t("EXTRAS.shipment")} {idx + 1}
                                    </h3>
                                    <p className="screen__titleEC-subtitle">
                                      {t("EXTRAS.shippingAddress")}:
                                    </p>
                                  </div>
                                )}
                                <input
                                  ref={(el) => (ref.current[idx].name = el)}
                                  name="nombre"
                                  type="text"
                                  defaultValue={
                                    extras_inputListEC[idx].contactData &&
                                    extras_inputListEC[idx].contactData.nombre
                                  }
                                  placeholder={t("EXTRAS.name")}
                                />
                              </div>
                              <div className="screen__inputContainerEC">
                                <input
                                  ref={(el) => (ref.current[idx].address = el)}
                                  name="direccion"
                                  type="text"
                                  defaultValue={
                                    extras_inputListEC[idx].contactData &&
                                    extras_inputListEC[idx].contactData
                                      .direccion
                                  }
                                  placeholder={t("EXTRAS.address")}
                                />
                              </div>
                              <div className="screen__inputContainerEC">
                                <input
                                  ref={(el) => (ref.current[idx].state = el)}
                                  name="poblacion"
                                  type="text"
                                  defaultValue={
                                    extras_inputListEC[idx].contactData &&
                                    extras_inputListEC[idx].contactData
                                      .poblacion
                                  }
                                  placeholder={t("EXTRAS.state")}
                                />
                              </div>
                              <div className="screen__inputContainerEC">
                                <input
                                  name="codigoPostal"
                                  type="text"
                                  defaultValue={
                                    extras_inputListEC[idx].contactData &&
                                    extras_inputListEC[idx].contactData
                                      .codigoPostal
                                  }
                                  placeholder={t("EXTRAS.zipCode")}
                                  ref={(el) => (ref.current[idx].zipCode = el)}
                                />
                              </div>
                              <div className="screen__inputContainerEC">
                                <input
                                  name="telefono"
                                  type="text"
                                  defaultValue={
                                    extras_inputListEC[idx].contactData &&
                                    extras_inputListEC[idx].contactData.telefono
                                  }
                                  placeholder={t("EXTRAS.phone")}
                                  ref={(el) => (ref.current[idx].phone = el)}
                                />
                              </div>
                              {extras_inputListEC.length > 1 ? (
                                <div className="screen__secondaryTitleEC">
                                  <h3 className="screen__secondaryTitleEC-title">
                                    {t("EXTRAS.navigationLicenses")}
                                  </h3>
                                  <p className="screen__secondaryTitleEC-subtitle">
                                    ({t("EXTRAS.shipment")} {idx + 1})
                                  </p>
                                </div>
                              ) : (
                                <h3 className="screen__titleEC">
                                  {t("EXTRAS.navigationLicense")}
                                </h3>
                              )}
                              {idx === extras_inputListEC.length - 1 &&
                              courseQuantity % 4 !== 0
                                ? Array(courseQuantity % 4)
                                    .fill("")
                                    .map((_, i) => {
                                      const nombreEnvio = `nombre${i + 1}`;
                                      return (
                                        <div
                                          className="screen__inputContainerEC"
                                          key={extras_inputListEC.length + i}
                                        >
                                          <input
                                            name={`nombreEnvio${i + 1}`}
                                            type="text"
                                            placeholder={t(
                                              "EXTRAS.licenseName"
                                            )}
                                            // defaultValue={
                                            //   extras_inputListEC[idx]
                                            //     .certificatesList &&
                                            //   extras_inputListEC[idx]
                                            //     .certificatesList[i]
                                            // }
                                            ref={(el) =>
                                              (ref.current[idx][nombreEnvio] =
                                                el)
                                            }
                                          />
                                        </div>
                                      );
                                    })
                                : Array(4)
                                    .fill("")
                                    .map((_, i) => {
                                      const nombreEnvio = `nombre${i + 1}`;
                                      return (
                                        <div
                                          className="screen__inputContainerEC"
                                          key={extras_inputListEC.length + i}
                                        >
                                          <input
                                            name={`nombreEnvio${i + 1}`}
                                            type="text"
                                            placeholder={t(
                                              "EXTRAS.licenseName"
                                            )}
                                            // defaultValue={
                                            //   extras_inputListEC[idx]
                                            //     .certificatesList &&
                                            //   extras_inputListEC[idx]
                                            //     .certificatesList[i]
                                            // }
                                            ref={(el) =>
                                              (ref.current[idx][nombreEnvio] =
                                                el)
                                            }
                                          />
                                        </div>
                                      );
                                    })}
                            </div>
                          );
                        })}
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </SlideDown>
        </div>
      </>
    );
  }
);
